export const getInviteDetail = state => state.data.inviteDetail;

export const getTermPageStepper = state => state.data.termPage.stepper;
export const getTermPageCurrentStep = state =>
  state.data.termPage.stepper.currentStep;
export const getTermPageStepperSteps = state =>
  state.data.termPage.stepper.steps;

export const getInviteMode = state => state.data.inviteMode;
